<script lang="ts">
  import { SizeHelper } from '@athena-lib/ProductWizard/helper/SizeHelper';
  import { ProductWizardContext } from '@athena-lib/ProductWizard/context/ProductWizardContext';
  import type { BackgroundOption } from '@athena-lib/BackgroundSelector';
  import type { ProductItemDimensions } from '../types';

  type StickerPreviewRulerProps = {
    show: boolean;
    uniqueId: string;
    productItemDimensions?: ProductItemDimensions;
    backgroundOption: BackgroundOption;
  };

  let { show, uniqueId, productItemDimensions, backgroundOption }: StickerPreviewRulerProps =
    $props();
  let x: number = $state(0);
  let y: number = $state(0);
  let width: number = $state(0);
  let height: number = $state(0);
  let rulerHeight: number = $state(0);

  const context = new ProductWizardContext();
  const sizeHelper = new SizeHelper(context);

  window.onresize = () => {
    updateDimensions();
  };

  $effect(() => {
    if (show) {
      updateDimensions();
    }
  });

  function updateDimensions() {
    const baseplateLayer = document.getElementById(`baseplateLayer-${uniqueId}`);
    if (!baseplateLayer) {
      return;
    }

    x = baseplateLayer.getBoundingClientRect().x;
    y = baseplateLayer.getBoundingClientRect().y;
    width = baseplateLayer.getBoundingClientRect().width;
    height = baseplateLayer.getBoundingClientRect().height;

    rulerHeight = 30 + height * 0.02;
  }

  function displayableMeasure(valueMM: number | undefined): string {
    if (!productItemDimensions || !valueMM) {
      return '';
    }

    if (productItemDimensions.imperialUnits) {
      return `${sizeHelper.convertMMToInches(valueMM).toString()} "`;
    }
    return `${sizeHelper.convertMMToCM(valueMM).toString()} cm`;
  }
</script>

{#if show}
  <div
    class="ruler width"
    style={`top: ${y - 60}px; left: ${x}px; width: ${width}px; height: ${rulerHeight}px;`}
  >
    <div class={`left-line-container ${backgroundOption}`}>
      <div class={`line ${backgroundOption}`}></div>
    </div>
    <div class={`text ${backgroundOption}`}>
      {displayableMeasure(productItemDimensions?.widthMM)}
    </div>
    <div class={`right-line-container ${backgroundOption}`}>
      <div class={`line ${backgroundOption}`}></div>
    </div>
  </div>
  <div
    class="ruler height"
    style={`left: ${x - 60}px; top: ${y}px; height: ${height}px; width: ${rulerHeight}px;`}
  >
    <div class={`top-line-container ${backgroundOption}`}>
      <div class={`line ${backgroundOption}`}></div>
    </div>
    <div class={`text ${backgroundOption}`}>
      {displayableMeasure(productItemDimensions?.heightMM)}
    </div>
    <div class={`bottom-line-container ${backgroundOption}`}>
      <div class={`line ${backgroundOption}`}></div>
    </div>
  </div>
{/if}

<style>
  .ruler {
    position: absolute;
    display: flex;
    &.width {
      flex-direction: row;
      .left-line-container {
        width: 40%;
        display: flex;
        align-items: center;
        border-left: 1px solid;
        border-color: grey;
        &.dark {
          border-color: rgb(77, 77, 77);
        }
      }
      .right-line-container {
        width: 40%;
        display: flex;
        align-items: center;
        border-right: 1px solid;
        border-color: grey;
        &.dark {
          border-color: rgb(77, 77, 77);
        }
      }
      .line {
        height: 1px;
        background-color: grey;
        width: 100%;
        &.dark {
          background-color: rgb(77, 77, 77);
        }
      }
      .text {
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: bold;
        color: grey;
        &.dark {
          color: rgb(77, 77, 77);
        }
      }
    }
    &.height {
      flex-direction: column;
      align-items: center;
      .top-line-container {
        height: 30%;
        width: 100%;
        justify-content: center;
        display: flex;
        align-items: center;
        border-top: 1px solid;
        border-color: grey;
        &.dark {
          border-color: rgb(77, 77, 77);
        }
      }

      .bottom-line-container {
        height: 30%;
        width: 100%;
        justify-content: center;
        display: flex;
        align-items: center;
        border-bottom: 1px solid;
        border-color: grey;

        &.dark {
          border-color: rgb(77, 77, 77);
        }
      }
      .line {
        width: 1px;
        background-color: grey;
        height: 100%;
        &.dark {
          background-color: rgb(77, 77, 77);
        }
      }
      .text {
        height: 40%;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: bold;
        color: grey;
        transform: rotate(-90deg);
        &.dark {
          color: rgb(77, 77, 77);
        }
      }
    }
  }
</style>
